import LevelDataBuilder from 'app/src/LevelDataBuilder';
import { LevelDescription } from 'app/src/LevelDescription';
import LevelParser from 'app/src/LevelParser';
import LocalStorageManager from 'app/src/utils/LocalStorageManager';
import * as React from 'react';

type ReturnType = {
	getEditorLevelDescription: () => LevelDescription | null;
	saveEditorLevelDescription: (levelDescription: LevelDescription) => void;
};

export default function useEditorLocalStorage(): ReturnType {
	const getEditorLevelDescription = React.useCallback((): LevelDescription | null => {
		const markup = LocalStorageManager.sharedInstance.getEditorLevelData();
		if (!markup) {
			return null;
		}

		const levelData = JSON.parse(markup);
		const levelDescription = LevelParser.sharedInstance.parse(levelData);

		return levelDescription;
	}, []);

	// Save the editor context.
	const saveEditorLevelDescription = React.useCallback(
		(levelDescription: LevelDescription): void => {
			const levelData = LevelDataBuilder.sharedInstance.build(levelDescription);
			const markup = JSON.stringify(levelData);

			LocalStorageManager.sharedInstance.saveEditorLevelData(markup);
		},
		[],
	);

	return {
		getEditorLevelDescription,
		saveEditorLevelDescription,
	};
}
